import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const deleteTrial = async ({ trialId }) => {
  const token = localStorage.getItem("token");

  const response = await axios.delete(`${__API_URL__}/api/photos/delete_trial/${trialId}/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useDeleteTrialMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteTrial,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["trials_list"] });
    },
  });
};

export default useDeleteTrialMutation;
